module.exports = __webpack_public_path__ + "img/Worth_School_Juniors Film.5f7e5739.jpg";